import { LeftOutlined, NotificationFilled, RightOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Drawer, Select } from "antd";
import InProgressOrder from "../components/MyOrders/InProgressOrder";
import ServiceRequest from "../components/MyOrders/ServiceRequest";
import ServiceRequestFinished from "../components/MyOrders/ServiceRequestFinished";
import prev from "../assets/previewRequests/prev.png";
import { fetchAllNotification, markAsViewed } from "../redux/allNotificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderById } from "../redux/ShowOrderIdSlice";
import { useTranslation } from "react-i18next";

const AllNotifications = () => {

    const { t, i18n } = useTranslation();
    const { language } = i18n;

    const [filter, setFilter] = useState("all");

    const handleChange = (value) => {
        setFilter(value);
    };

    const dispatch = useDispatch();

    const { allNotification, status, error } = useSelector(
        (state) => state.allNotification
    );
    const [orderIcons, setOrderIcons] = useState({});

    console.log(allNotification);

    useEffect(() => {
        dispatch(fetchAllNotification());
    }, [dispatch]);

    // useEffect(() => {
    //     if (allNotification?.data?.length > 0) {
    //         allNotification.data.forEach((not) => {
    //             dispatch(fetchOrderById(not.notifiable_id)).then((action) => {
    //                 if (action.payload && action.payload.category) {
    //                     const categoryIcon = action.payload.category.icon;
    //                     setOrderIcons((prevIcons) => ({
    //                         ...prevIcons,
    //                         [not.notifiable_id]: categoryIcon,
    //                     }));
    //                 }
    //             });
    //         });
    //     }
    // }, [allNotification, dispatch]);

    const handleNotificationClick = (notificationId) => {
        dispatch(markAsViewed(notificationId)).then(() => {
            dispatch(fetchAllNotification());
        });
    };

    const filteredNotifications = allNotification?.data?.filter((not) => {
        if (filter === "all") return true;
        if (filter === "orders") return not.type === "order";
        if (filter === "perviews") return not.type === "construction_preview";
        return true;
    });


    return (
        <div className="all_orders">
            <div className="bg-[#FCFBFA] px-20 max-lg:px-5 py-8 sticky top-0">
                <Link to="/" className='flex items-center text-[#283D63] font-semibold'>
                    {
                        language == "en" ? <>
                            <LeftOutlined />
                            <p className='ml-3'>{t("Back to home")}</p>
                        </> : <>
                            <RightOutlined />
                            <p className='mr-3'>{t("Back to home")}</p>
                        </>
                    }
                </Link>

                <div className="lg:flex items-center justify-between mt-8">
                    <div className="flex items-center">
                        <h2 className="text-[#14294F] font-semibold text-2xl">{t("All Notifications")}</h2>
                    </div>
                    <div className="flex items-center max-lg:mt-4">
                        <p className={`${language == "en" ? "mr-3" : "ml-3 "} text-[#283D63] font-semibold`}>{t("Filter")}</p>
                        <Select
                            defaultValue="all"
                            style={{
                                width: 220,
                            }}
                            className="border-2 border-[#4F71A8] rounded-full"
                            onChange={handleChange}
                            options={[
                                {
                                    value: "orders",
                                    label: t("Service Orders"),
                                },
                                {
                                    value: "perviews",
                                    label: t("Preview Requests"),
                                },
                                {
                                    value: "all",
                                    label: t("All Notifications"),
                                },
                            ]}
                        />
                    </div>
                </div>

            </div>
            <div className="chat-box px-20 max-lg:px-5 py-5 pb-20">
                {/* {allNotification?.data?.length > 0 ?
                    allNotification?.data?.map((not, index) => {

                        const dateObject = not.updated_at ? new Date(not.updated_at) : null;

                        const formattedDate = dateObject
                            ? `${String(dateObject.getDate()).padStart(2, "0")}-${String(
                                dateObject.getMonth() + 1
                            ).padStart(2, "0")}-${dateObject.getFullYear()}`
                            : "N/A";
                        const formattedTime = dateObject
                            ? `${dateObject.getHours()}:${String(dateObject.getMinutes()).padStart(2, "0")}`
                            : "N/A";

                        const orderIcon = orderIcons[not.notifiable_id] || prev;

                        return (
                            <div className="flex items-center justify-between border-b pb-4 mb-4"
                                onClick={() => handleNotificationClick(not.id)}
                                key={not.id}
                            >
                                <div className="flex items-center" >
                                    {
                                        not.type == "construction_preview" ? <img src={prev} className="w-[100px] rounded-2xl" />
                                            : not.type == "order" ?
                                                <img src={prev} className="w-[100px] rounded-2xl" />
                                                :
                                                <div className="bg-[#fcfbfa] text-[#14294F] rounded-3xl p-4 w-[100px] h-[100px] mx-auto">
                                                    <NotificationFilled className="text-3xl mt-4 flex m-auto justify-center items-center" />
                                                </div>
                                    }

                                    <div className="ml-4">
                                        <p className="text-[#14294F] text-xl">{not.title_en}</p>
                                        <p className="text-[#737E91]">{not.body_en}</p>
                                    </div>
                                </div>
                                <p>{formattedDate} {formattedTime}</p>
                            </div>
                        )
                    })
                    :
                    <p className="text-[#737E91] text-xl text-center my-5">{t("No Notification")}</p>
                } */}
                {filteredNotifications?.length > 0 ? (
                    filteredNotifications.map((not) => {
                        const dateObject = not.updated_at ? new Date(not.updated_at) : null;

                        const formattedDate = dateObject
                            ? `${String(dateObject.getDate()).padStart(2, "0")}-${String(
                                dateObject.getMonth() + 1
                            ).padStart(2, "0")}-${dateObject.getFullYear()}`
                            : "N/A";
                        const formattedTime = dateObject
                            ? `${dateObject.getHours()}:${String(dateObject.getMinutes()).padStart(2, "0")}`
                            : "N/A";

                        return (
                            <div
                                className="flex items-center justify-between border-b pb-4 mb-4"
                                onClick={() => handleNotificationClick(not.id)}
                                key={not.id}
                            >
                                <div className="flex items-center">
                                    {not.type === "construction_preview" || not.type === "order" ? (
                                        <img src={prev} className="w-[100px] rounded-2xl" />
                                    ) : (
                                        <div className="bg-[#fcfbfa] text-[#14294F] rounded-3xl p-4 w-[100px] h-[100px] mx-auto">
                                            <NotificationFilled className="text-3xl mt-4 flex m-auto justify-center items-center" />
                                        </div>
                                    )}

                                    <div className={language == "en" ? "ml-4" : "mr-4"}>
                                        <p className="text-[#14294F] text-xl">{language == "en" ? not.title_en : not.title}</p>
                                        <p className="text-[#737E91]">{language == "en" ? not.body_en : not.body}</p>
                                    </div>
                                </div>
                                <p>{formattedDate} {formattedTime}</p>
                            </div>
                        );
                    })
                ) : (
                    <p className="text-[#737E91] text-xl text-center my-5">{t("No Notification")}</p>
                )}
            </div>
        </div>
    );
};

export default AllNotifications;
